import {connect} from "react-redux";
import CreateDealer from "./CreateDealer";
import {bindActionCreators} from "redux";
import {saveLead, getLeadById, searchDealerMaster} from "../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    lead:state.Lead.lead,
    leadById:state.Lead.leadById,
    searchMasterDealer:state.Lead.searchMasterDealer,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            saveLead,
            getLeadById,
            searchDealerMaster
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CreateDealer);
